import React from 'react'

import { MenuItem, TextField } from '@mui/material'

import { eTypePickingRoute } from '../../../enums/eTypePickingRoute'

interface PickingTypeSelectProps {
  selectedType: eTypePickingRoute
  onChange: (value: eTypePickingRoute) => void
}

const PickingTypeSelect: React.FC<PickingTypeSelectProps> = ({
  selectedType,
  onChange
}) => {
  const handleSelectionChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    onChange(event.target.value as eTypePickingRoute)
  }

  const formatLabel = (text: string) =>
    text
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase())

  return (
    <TextField
      value={selectedType}
      onChange={handleSelectionChange}
      label='Tipo de Picking'
      fullWidth
      select
      variant='outlined'
      inputProps={{
        style: { textAlign: 'center' }
      }}
    >
      {Object.entries(eTypePickingRoute)
        .filter(([key]) => isNaN(Number(key))) // Filtrar las claves numéricas que agrega TS
        .filter(([key]) => key !== 'ExternalStorage')
        .map(([key, value]) => (
          <MenuItem key={value} value={value}>
            {formatLabel(key)}
          </MenuItem>
        ))}
    </TextField>
  )
}

export default PickingTypeSelect
